import React__default from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { c as commonPropTypes } from './commonPropTypes-b8a00f98.js';
import { F as FormIntent, T as TooltipThemes } from './types-377ea632.js';
import { T as Tooltip, D as DEFAULT_TOOLTIP_Z_INDEX } from './Tooltip-63e0cd1c.js';
import { S as SvgError } from './error-e6cc4025.js';
import '@tippy.js/react';

var styles = {"feedback-tooltip-content":"FeedbackTooltip-module_feedback-tooltip-content__2LcZe"};

const feedbackTooltipMaxWidth = 350;
const intentList = [FormIntent.ERROR, FormIntent.WARNING];
const FeedbackTooltip = ({
  appendTo = () => document.body,
  children = null,
  className,
  content = null,
  fillWidth = false,
  intent = null,
  interactive = true,
  isTabletMobile = false,
  maxWidth = feedbackTooltipMaxWidth,
  placement = 'right',
  placementFlipped = 'bottom',
  theme = TooltipThemes.LIGHT,
  tooltipIcon = null,
  zIndex = DEFAULT_TOOLTIP_Z_INDEX
}) => {
  const renderTooltipOverlay = feedbackContent => /*#__PURE__*/React__default.createElement("div", {
    className: styles['feedback-tooltip-content']
  }, tooltipIcon || /*#__PURE__*/React__default.createElement(SvgError, null), /*#__PURE__*/React__default.createElement("p", null, feedbackContent));
  const visible = intentList.includes(intent) && !!content;
  const sameWidthAsParent = isTabletMobile || fillWidth;
  const tooltipProps = {
    appendTo: sameWidthAsParent ? 'parent' : appendTo,
    bordered: true,
    className: cx(styles['feedback-tooltip'], className),
    flip: false,
    flipBehavior: [placement, placementFlipped],
    flipOnUpdate: true,
    interactive,
    maxWidth,
    overlay: renderTooltipOverlay(content),
    placement,
    tooltipTheme: theme,
    visible,
    zIndex
  };
  return /*#__PURE__*/React__default.createElement(Tooltip, tooltipProps, children);
};
FeedbackTooltip.propTypes = {
  /**
    * Element to which tooltip will be append
  */
  appendTo: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.node, PropTypes.shape({})]),
  /**
   * Tooltip anchor element - anything that can be rendered: numbers, strings, elements or an array
  */
  children: commonPropTypes.children.isRequired,
  /**
   * ClassName
  */
  className: commonPropTypes.className,
  /**
   * Anything that can be rendered inside tooltip: numbers, strings, elements or an array
  */
  content: commonPropTypes.children,
  /**
   * Tooltip has the same width as a parent
  */
  fillWidth: PropTypes.bool,
  /**
    * State like error, success, warning
  */
  intent: PropTypes.oneOf(Object.values(FormIntent)),
  /**
  * Content inside can be hovered over and clicked
  */
  interactive: PropTypes.bool,
  /**
    * TabletMobile breakpoint
  */
  isTabletMobile: PropTypes.bool,
  /**
    * Maximum width of tooltip
  */
  maxWidth: PropTypes.number,
  /**
    * Placement of tooltip like top, left...
  */
  placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left', 'topLeft', 'topRight']),
  placementFlipped: PropTypes.string,
  /**
   * Component theme - light or dark
  */
  theme: PropTypes.oneOf(Object.values(TooltipThemes)),
  /**
    * Icon inside tooltip, default is ErrorIcon
  */
  tooltipIcon: PropTypes.element,
  /**
    * zIndex of tooltip
  */
  zIndex: PropTypes.number
};

export { FeedbackTooltip as default };
